import ConnectAccountsForm from "@/components/multi-step-forms/connect-account";
import { buildMetadata } from "@/lib/metadata";
import { WhapiService } from "@/services/whapi-service";
import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

export const Route = createFileRoute("/_onboarding/connect-account")({
  component: RouteComponent,
  validateSearch: z.object({
    intent: z.enum(["reconnect", "onboarding"]).optional().catch(undefined),
    step: z.enum(["qr", "connect"]).optional().catch(undefined),
  }),
  head: () => ({
    meta: buildMetadata({
      title: "Connect Account",
      description: "Connect your account to OpenFarming",
      keywords: ["connect", "account", "openfarming"],
    }),
  }),
  loader: async () => {
    return await WhapiService.getWhatsAppChannel();
  },
});

function RouteComponent() {
  const data = Route.useLoaderData();
  const search = Route.useSearch();

  return (
    <div className="h-full w-full p-8">
      <ConnectAccountsForm status={data?.auth_status} search={search} />
    </div>
  );
}
